import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    api.post("/auth/session", { session_id: sessionId })
      .then(({ data }) => {
        setUser(data);
        toast.success(`Welcome, ${data.name}`);
        navigate("/join", { replace: true });
      })
      .catch(() => {
        toast.error("Sign in failed");
        navigate("/", { replace: true });
      });
  }, [location.hash, navigate, setUser]);

  return null;
}
